import React from 'react';
import { Save } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Switch } from '../../../components/ui/switch';
import { Textarea } from '../../../components/ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../../components/ui/dialog';

export const EditClientTypeDialog = ({ editingType, setEditingType, onSave }) => (
  <Dialog open={!!editingType} onOpenChange={() => setEditingType(null)}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Edit Client Type</DialogTitle>
        <DialogDescription>Update settings for {editingType?.name}</DialogDescription>
      </DialogHeader>

      {editingType && (
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="edit-name">Name</Label>
            <Input
              id="edit-name"
              value={editingType.name}
              onChange={(e) => setEditingType({ ...editingType, name: e.target.value })}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="edit-description">Description</Label>
            <Textarea
              id="edit-description"
              value={editingType.description}
              onChange={(e) => setEditingType({ ...editingType, description: e.target.value })}
              rows={2}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="edit-discount">Default Discount (%)</Label>
            <Input
              id="edit-discount"
              type="number"
              min="0"
              max="100"
              value={editingType.default_discount_percent}
              onChange={(e) => setEditingType({ ...editingType, default_discount_percent: parseFloat(e.target.value) || 0 })}
            />
          </div>

          <div className="flex items-center justify-between">
            <div>
              <Label>Guaranteed Returns</Label>
              <p className="text-xs text-gray-500">Allow invoice adjustments</p>
            </div>
            <Switch
              checked={editingType.has_guaranteed_returns}
              onCheckedChange={(checked) => setEditingType({ ...editingType, has_guaranteed_returns: checked })}
            />
          </div>

          {editingType.has_guaranteed_returns && (
            <div className="space-y-2">
              <Label>Adjustment Window (business days)</Label>
              <Input
                type="number"
                min="1"
                max="30"
                value={editingType.adjustment_window_days}
                onChange={(e) => setEditingType({ ...editingType, adjustment_window_days: parseInt(e.target.value) || 7 })}
              />
            </div>
          )}

          <div className="flex items-center justify-between">
            <Label>Active</Label>
            <Switch
              checked={editingType.is_active}
              onCheckedChange={(checked) => setEditingType({ ...editingType, is_active: checked })}
            />
          </div>
        </div>
      )}

      <DialogFooter>
        <Button variant="outline" onClick={() => setEditingType(null)}>Cancel</Button>
        <Button
          onClick={() =>
            onSave(editingType.id, {
              name: editingType.name,
              description: editingType.description,
              default_discount_percent: editingType.default_discount_percent,
              has_guaranteed_returns: editingType.has_guaranteed_returns,
              adjustment_window_days: editingType.adjustment_window_days,
              is_active: editingType.is_active,
            })
          }
          className="bg-amber-500 hover:bg-amber-600"
          data-testid="save-client-type-btn"
        >
          <Save className="h-4 w-4 mr-2" />
          Save Changes
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
